
import React, { Component } from 'react';
import {Link} from 'react-router-dom';

//Other Helpers
import BlurImageLoader from 'react-blur-image-loader'

class AboutBanner extends React.Component {
	render() {
		return ( 
            <section className="container">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="featued-container">
                            <div className="row">
                                <div className="col-sm-6 col-sm-offset-6">
                                    <div className="featured-wrapper">
                                        <h2>Om Os</h2>
                                        <p>Just so you understand how really huge our fleet of bicycle models is, take a look at this video, featuring all 250 of those we have in stock!</p>
                                        <p>Among other ones, we have the following types available: Cyclocross bicycles; Touring bicycles; Triathlon/Time Trial Bicycles; Flat-Bar Road Bicycles; Track/Fixed-Gear Bicycles…</p>
                                        <Link to="/about" className="btn btn-default btn-lg">Læs Mere</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
	}
}

export default AboutBanner;


// WEBPACK FOOTER //
// ./src/Components/AboutBanner.js